import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import SvgIcon from "./components/tools/SvgIcon.vue";
import * as Chart from "chart.js";
import VueChartkick from "vue-chartkick";
import VueMq from 'vue-mq';
import Modal from "./components/tools/Modal.vue";
import Panel from './components/tools/Panel.vue';
import Tabs from "@/components/navigation/Tabs.vue";
import TabSection from "@/components/navigation/TabSection.vue";
import Tooltip from './components/tools/Tooltip.vue';
import Tag from "./components/tools/Tag.vue";
import Tipbox from "./components/tools/TipBox.vue";
import InventoryUsagePanel from "./components/InventoryUsagePanel.vue";
import { ModalPlugin } from './components/tools/ModalEventBus';
import { Localize, LocalizeStore } from './resources/localize';
import Validate from "./resources/validate2";
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css';
import VueHtmlToPaper from 'vue-html-to-paper';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueIntercom from "vue-intercom";

require("./assets/style/fonts.css");
require("./resources/toast");
require("./global.js");
require("./nw-update.js");

Vue.config.productionTip = false;

Vue.component("svgicon", SvgIcon);
Vue.component("Modal", Modal);
Vue.component('multiselect', Multiselect);
Vue.component("TipBox", Tipbox);
Vue.component("Tooltip", Tooltip);
Vue.component("Panel", Panel);
Vue.component("tag", Tag);
Vue.component("Tabs", Tabs);
Vue.component("TabSection", TabSection);
Vue.component("InventoryUsagePanel", InventoryUsagePanel);
Vue.use(Localize);
Vue.use(ModalPlugin);
Vue.use(Datetime);
Vue.use(Validate);
Vue.use(VueChartkick, {adapter: Chart});
Vue.use(VueMq, {
  breakpoints: {
    xs: 575,
    sm: 767,
    md: 1100,
    lg: 1199,
    xl: Infinity
  }
});
Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=no',
    'scrollbars=yes'
  ],
  styles: [
    'print.css'
  ]
});


window.translate = LocalizeStore.getters.get;
window.translateObject = LocalizeStore.getters.getFromObject;

router.redirectToLogin = function() {
  let route = this.currentRoute;
  if (route.name === "login" && route.query.redirect) {
    return;
  }
  this.push({
    name: "login",
    query: {
      redirect: encodeURIComponent(route.fullPath)
    }
  })
};

router.buildContext = function(url, data = {}) {
  if (this.currentRoute.query.branch && !data.branch) {
    data.branch = this.currentRoute.query.branch;
  }
  if (this.currentRoute.query.company && !data.company) {
    data.company = this.currentRoute.query.company;
  }
  if (this.currentRoute.query.inventory && !data.inventory) {
    data.inventory = this.currentRoute.query.inventory;
  }
  let keys = Object.keys(data);
  if (keys.length === 0) {
    return url;
  }
  url += "?";
  for (let key of keys) {
    url += key + "=" + data[key] + "&";
  }
  return url.substring(0, url.length - 1);
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

window.store = store;

const routingPermissions = {
  superAdmin: [
    'branches', 'branchEdit', 'branchNew',
    'imageClassification', 'trainingImageClassification', 'recommenderAnalysis',
    'cloneInventory', 'moveCompany'
  ],
  distributor: [
    'failedSale', 'salesStatus',
  ],
  branchAdmin: [
    'onlineOrderingStyle'
  ]
};

router.beforeEach((to, from, next) => {
  if (!store.state.loggedUser && aclExceptions.indexOf(to.name) === -1) {
    this.redirectToLogin();
    return;
  }
  let branchId = to.query.branch;
  let companyId = to.query.company;

  /* Guard routing when the the user doesn't own branch and company */
  if ((branchId && store.state.loggedUser.branch && parseInt(branchId) !== store.state.loggedUser.branch)
    || (companyId && store.state.loggedUser.company && parseInt(companyId) !== store.state.loggedUser.company)
    || (!companyId && store.state.loggedUser.company)
  ) {
    next(false);
    return;
  }

  /* Guard routing with permission level */
  if ((!store.getters.loggedUserHasSuperAdmin && routingPermissions.superAdmin.includes(to.name))
    || (!store.getters.loggedUserHasDistributor && routingPermissions.distributor.includes(to.name))
    || (!store.getters.loggedUserHasBranchAdmin && routingPermissions.branchAdmin.includes(to.name))
  ) {
    next(false);
    return;
  }

  store.commit('currentPageActions', []);
  store.commit("setContext", {branchId, companyId} );
  store.commit("setHeaderMenuVisible", null);
  store.state.pageTitle = null;

  next();
});

let aclExceptions = ["login", "resetpassword"];
